import React, { forwardRef } from 'react';
import { MenuList as ChakraMenuList, Portal } from '@chakra-ui/react';

export const MenuList = forwardRef(function MenuList(props, ref) {
  return (
    <Portal>
      <ChakraMenuList ref={ref} zIndex="menu" {...props} />
    </Portal>
  );
});

export default MenuList;
